import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { environment } from '@env/environment';
import { Site } from '@shared/models/site.model';
import { ApiResponse } from '@shared/models/api-response.model';
import { siteDomain } from '@core/entity/site-domain/model/site-domain.model';

@Injectable({
  providedIn: 'root'
})
export class SiteHttpService {

  website: any;
  chat_page: any;
  live_chat_platform_id: any;
  live_chat_platform_name: any;
  aesEncryptionKey:string = environment.aesEncryptionKey
  
  constructor(private http: HttpClient) { }

  getLiveChatScript(Param: string): Observable<Site> {
    return this.http.get<ApiResponse>(`/livechat/getscript${Param}`).pipe(
      map(res => {
        if( res.data != null  ){
          this.website = res.data.rows.website;
          this.chat_page = res.data.rows.chat_page;
          this.live_chat_platform_id = res.data.rows.live_chat_platform_id;
          this.live_chat_platform_name = res.data.rows.live_chat_platform_name;
          return res.data.rows
        } 
        this.website = '';
        this.chat_page = '';
        this.live_chat_platform_id = '';
        this.live_chat_platform_name = '';
        return res.data;
      }),
    );
  }  

  getSiteDomain(): Observable<siteDomain[]>{
    return this.http.get<ApiResponse>(`/sitedomain`).pipe(
      map(res => {        
        return res.data.rows
      }),
    );
  }

  encrypt(params:Object){
    return encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(params), this.aesEncryptionKey).toString())
  }

  decrypt(ciphertext:string){
    return JSON.parse(CryptoJS.AES.decrypt(decodeURIComponent(ciphertext), this.aesEncryptionKey).toString(CryptoJS.enc.Utf8));
  }

  getMiniGameScript() {
    return this.http.get<ApiResponse>(`/minigame/gettoken`).pipe(
      map(res => {
        return res.data;
      }),
    );
  } 
}
